interface Props {
  full?: boolean;
  half?: boolean;
  color: string;
  size: string | number;
}

const Star = (props: Props) => {
  const { full, half, color, size } = props;

  return (
    <div
      sx={{
        px: "1px",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 100 100"
      >
        <g>
          <rect
            width="100"
            height="100"
            fill={full && !half ? color : "#dcdce6"}
          />
          <rect
            y="0"
            width="50"
            height="100"
            fill={!full && half ? color : "transparent"}
          />
          <g>
            <path
              fill="#FFF"
              d="m15.22,42h.63c8.57,0,17.13,0,25.7,0,.41,0,.61-.09.74-.52,2.63-8.1,5.28-16.2,7.92-24.3.04-.12.09-.25.17-.49.08.23.13.35.17.47,2.64,8.1,5.29,16.2,7.92,24.3.13.4.3.54.73.53,8.57-.01,17.13-.01,25.7-.01h.51l.04.11c-11.63,8.41-23.26,16.82-34.89,25.23,0,.02.02.05.03.07,5-1.27,10.01-2.53,15.08-3.82,2.12,6.53,4.24,13.05,6.39,19.69-7.29-5.32-14.48-10.56-21.69-15.82-7.19,5.18-14.38,10.36-21.67,15.62.19-.6.35-1.09.51-1.58,2.53-7.77,5.07-15.53,7.61-23.29.12-.36.07-.56-.25-.79-6.97-5-13.92-10.02-20.88-15.04-.13-.09-.25-.19-.48-.37Z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Star;
